import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../../const";
import { fetchKids } from "../../../Kids-list.ducks";
import _ from 'lodash';
import { Service } from "../../../../../service/service"
import { unAuthorized } from '../../../../../auth/Auth.ducks'
// Depart actions

export const POST_DEPART_PENDING = "POST_DEPART_PENDING";
export const POST_DEPART_REJECTED = "POST_DEPART_REJECTED";
export const POST_DEPART_FULFILLED = "POST_DEPART_FULFILLED";

export const GET_DEPART_PENDING = "GET_DEPART_PENDING";
export const GET_DEPART_REJECTED = "GET_DEPART_REJECTED";
export const GET_DEPART_FULFILLED = "GET_DEPART_FULFILLED";

export const PUT_DEPART_PENDING = "PUT_DEPART_PENDING";
export const PUT_DEPART_REJECTED = "PUT_DEPART_REJECTED";
export const PUT_DEPART_FULFILLED = "PUT_DEPART_FULFILLED";

export const DELETE_DEPART_PENDING = "DELETE_DEPART_PENDING";
export const DELETE_DEPART_REJECTED = "DELETE_DEPART_REJECTED";
export const DELETE_DEPART_FULFILLED = "DELETE_DEPART_FULFILLED";
const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_DEPART_PENDING:
    case GET_DEPART_PENDING:
    case PUT_DEPART_PENDING:
    case DELETE_DEPART_PENDING:

      return true;
    case POST_DEPART_REJECTED:
    case POST_DEPART_FULFILLED:
    case GET_DEPART_REJECTED:
    case GET_DEPART_FULFILLED:
    case PUT_DEPART_REJECTED:
    case PUT_DEPART_FULFILLED:
    case DELETE_DEPART_REJECTED:
    case DELETE_DEPART_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_DEPART_PENDING:
    case POST_DEPART_FULFILLED:
    case GET_DEPART_PENDING:
    case GET_DEPART_FULFILLED:
    case PUT_DEPART_PENDING:
    case PUT_DEPART_FULFILLED:
    case DELETE_DEPART_PENDING:
    case DELETE_DEPART_FULFILLED:
      return null;
    case POST_DEPART_REJECTED:
    case GET_DEPART_REJECTED:
    case PUT_DEPART_REJECTED:
    case DELETE_DEPART_REJECTED:

      return { ...state, showError: true };
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_DEPART_FULFILLED:
    case GET_DEPART_FULFILLED:
    case PUT_DEPART_FULFILLED:
    case DELETE_DEPART_FULFILLED:

      return _.isEmpty(payload.data) ? null : payload.data;
    case POST_DEPART_PENDING:
    case GET_DEPART_PENDING:
    case PUT_DEPART_PENDING:
      return null;
    case POST_DEPART_REJECTED:
    case GET_DEPART_REJECTED:
    case PUT_DEPART_REJECTED:
      return null;

    default:
      return state;
  }
};

// Depart reducer
export default combineReducers({ loading, error, data });

export const postDepartSimple = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${id}/departs`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_DEPART_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_DEPART_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const getDepartEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/enfant/creche/departs/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_DEPART_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_DEPART_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const updateDepartEvent = (tok, idEvent, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/departs/${idEvent}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_DEPART_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: PUT_DEPART_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const DeleteDepartEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/enfant/creche/departs/${idEvent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_DEPART_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_DEPART_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
} 